var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle3, _path10, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredAnnouncement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9988,
    cy: 44.0007,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7376 43.4218L44.8161 31.9306L54.2371 50.5219L38.7903 52.1061",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5592 51.0834C24.8728 49.7289 25.4145 48.0744 26.769 47.388L34.6449 43.397L38.832 51.6598L30.9561 55.6509C29.6016 56.3372 27.9471 55.7956 27.2607 54.4411L25.5592 51.0834Z",
    fill: "white",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7266 54.0977L37.3829 61.3131C37.9715 62.4746 39.3729 62.9631 40.5559 62.4192V62.4192C41.8045 61.8451 42.3261 60.3487 41.705 59.1229L38.1321 52.0722",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8405 51.5258L40.3025 56.2362",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4219 34.7363L55.5026 31.435",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8945 40.5254L61.1958 41.6061",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7383 37.0527L61.9025 34.4358",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1641 29.0332L34.7098 29.0332M39.2578 29.0332L38.7121 29.0332",
    stroke: "#00193C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7109 31.5801L36.7109 30.625M36.7109 26.4863L36.7109 27.4414",
    stroke: "#00193C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0371,
    cy: 56.7891,
    r: 1.55508,
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9802 38.21C32.9802 39.7971 31.6936 41.0837 30.1065 41.0837C28.5194 41.0837 27.2328 39.7971 27.2328 38.21C27.2328 36.6229 28.5194 35.3363 30.1065 35.3363C31.6936 35.3363 32.9802 36.6229 32.9802 38.21Z",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.8438,
    y: 30.1055,
    width: 4.63158,
    height: 25.4737,
    rx: 2.31579,
    transform: "rotate(-26.8733 42.8438 30.1055)",
    fill: "#0E5CF4",
    stroke: "#20242E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredAnnouncement);
export default __webpack_public_path__ + "static/media/ic-colored-announcement.88c0541c9760177eb06526f03199e1e2.svg";
export { ForwardRef as ReactComponent };